export const blockIconsCommunicationImportContacts = (
	<span className='material-symbols-outlined'>import_contacts</span>
);
